module.exports = "<div class=\"slideshow\">\n    <ng-content>\n    \n    </ng-content>\n</div>\n"